export default __webpack_public_path__ + "static/media/3005.8eb0bc4f.jpg";